import { render, staticRenderFns } from "./SelectGoods.vue?vue&type=template&id=62f1f7b2&scoped=true"
import script from "./SelectGoods.vue?vue&type=script&lang=js"
export * from "./SelectGoods.vue?vue&type=script&lang=js"
import style0 from "./SelectGoods.vue?vue&type=style&index=0&id=62f1f7b2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f1f7b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/test-cdp-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62f1f7b2')) {
      api.createRecord('62f1f7b2', component.options)
    } else {
      api.reload('62f1f7b2', component.options)
    }
    module.hot.accept("./SelectGoods.vue?vue&type=template&id=62f1f7b2&scoped=true", function () {
      api.rerender('62f1f7b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newLabelManagement/labelManagement/components/SelectGoods.vue"
export default component.exports